import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
const BANNERS = [{
  src: 'https://cdn.magicpatterns.com/uploads/vtzSSMWkkUh9gcHUNAQZVu/bannermedio2.png',
  alt: 'Quinceañera, padrinos y familia celebrando frente al Mirror Photo Booth'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/pMF5HkvdgTxZU73KRWBWcX/bannermediofam.png',
  alt: 'Familias y amigos viviendo momentos divertidos con el Mirror Photo Booth'
}];
export function DreamSection() {
  return <section className="py-16 md:py-28 bg-ink relative overflow-hidden" data-id="element-86" data-mp="2bi711oafhwjz">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-87" data-mp="2q736ddl3ovgw">
        <div className="absolute top-[-10%] right-[-5%] w-96 h-96 bg-gold/5 rounded-full blur-3xl" data-id="element-88" data-mp="2ldqvs7d9ap75"></div>
        <div className="absolute bottom-[-10%] left-[-5%] w-96 h-96 bg-gold/5 rounded-full blur-3xl" data-id="element-89" data-mp="1xnmuw7rgd3ju"></div>
      </div>

      <div className="container mx-auto px-4 md:px-6 max-w-6xl relative z-10" data-id="element-90" data-mp="1sojw3522ftkb">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-10 md:mb-16" data-id="element-91" data-mp="3oxjp9ntigxef">
          <div className="flex justify-center mb-4" data-id="element-92" data-mp="31zggd8v3hx26">
            <Sparkles className="text-gold w-8 h-8 md:w-10 md:h-10" data-id="element-93" data-mp="35zqksh38ofex" />
          </div>

          <h2 className="font-script text-4xl md:text-6xl text-gold mb-4" data-id="element-94" data-mp="3axinm65f9lxw">
            Imagínate esto:
          </h2>

          <p className="text-base md:text-xl text-cream/80 font-light max-w-2xl mx-auto" data-id="element-95" data-mp="3fxo9t6sxag8l">
            Los abrazos, las miradas, las risas — todos congelados para siempre
            en una foto que se puede tocar.
          </p>
        </motion.div>

        {/* Cinematic banners stacked */}
        <div className="space-y-8 md:space-y-12" data-id="element-96" data-mp="5hh1du7g1nuc">
          {BANNERS.map((banner, i) => <motion.div key={banner.src} initial={{
          opacity: 0,
          scale: 0.97
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 1,
          delay: i * 0.15,
          ease: 'easeOut'
        }} className="relative w-full mx-auto" style={{
          WebkitMaskImage: 'radial-gradient(ellipse 95% 90% at 50% 50%, black 60%, transparent 100%)',
          maskImage: 'radial-gradient(ellipse 95% 90% at 50% 50%, black 60%, transparent 100%)'
        }} data-id="element-97" data-mp="k74xuln0bx0" data-mpi={i}>
              <img src={banner.src} alt={banner.alt} loading="lazy" decoding="async" className="w-full h-auto block object-cover" data-id="element-98" data-mp="2v5zsjwbp6ulm" />
              {/* Subtle cinematic gradients */}
              <div className="absolute inset-0 bg-gradient-to-t from-ink via-transparent to-transparent pointer-events-none" data-id="element-99" data-mp="10t6tm07ihijr"></div>
              <div className="absolute inset-0 bg-gradient-to-b from-ink/40 via-transparent to-transparent pointer-events-none" data-id="element-100" data-mp="15ocfx04tsz8d"></div>
            </motion.div>)}
        </div>

        {/* Closing pull quote */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1,
        delay: 0.2
      }} className="text-center pt-12 md:pt-20 mt-8 md:mt-12 border-t border-gold/10 max-w-4xl mx-auto" data-id="element-101" data-mp="1kfuxh2dc31tu">
          <p className="font-script text-3xl md:text-5xl lg:text-6xl text-gold leading-tight" data-id="element-102" data-mp="tb8sls040vyh">
            "No vendemos fotos. Creamos el momento en que tu familia tiene algo
            para atesorar toda la vida."
          </p>
        </motion.div>
      </div>
    </section>;
}